export enum Environments {
	PRODUCTION = "production",
	DEVELOPMENT = "development"
}

export const ENVIRONMENT = __ENVIRONMENT__ === "production" ? Environments.PRODUCTION : Environments.DEVELOPMENT;
export const isProduction = __ENVIRONMENT__ === "production";
